import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import { ToastContext } from "../../../../context/ToastContext";
import { InputSwitch } from "primereact/inputswitch";
import { useGlobalFields } from "../Fields/useGlobalFields";

export const useFieldConfigurationDetails = ({ filterValues, setFilterValues }) => {
    const { showSuccess, showError } = useContext(ToastContext);
    const { rowData } = useGlobalFields({ filterValues, setFilterValues });
    const [fieldData, setFieldData] = useState([]);
    const [loader, setLoader] = useState(false)
    const [option, setOption] = useState({});
    const multiSelectRef = useRef(null);


    useEffect(() => {
        (filterValues?.config?.field_configuration_id && filterValues?.apiCall) && getfieldConfigruationDetails();
    }, [filterValues?.apiCall]);

    useEffect(() => {
        const remainingFields = rowData?.filter(rowItem => !fieldData.some(fieldItem => fieldItem?.custom_field_id === rowItem?.custom_field_id));
        setOption({
            fields: remainingFields?.map((item) => ({
                ...item,
                custom_field_name: `${item?.custom_field_name} (${item?.field_type})`
            }))
        });

    }, [rowData, fieldData])

    const columns = [
        {
            key: "field",
            label: "Field",
            style: { width: "35%" },
            render: (row) => (
                <div className="d-flex align-items-center gap-2">
                    {row.isPrimary && (
                        <span className="badge bg-secondary-subtle text-secondary border-0 fw-bold"
                            style={{ fontSize: '7px', padding: '2px 4px' }}>
                            LOCKED
                        </span>
                    )}
                    <span className=" " >{row.custom_field_name}</span>
                    <span className="text-muted font-monospace ms-2" style={{ fontSize: '9px' }}>({row.fieldId})</span>
                </div>
            )
        },
        {
            key: "type",
            label: "Data type",
            style: { width: "15%" },
            render: (row) => (
                row?.schema_type && <span className=" bg-light text-muted fw-bold text-capitalize px-2 py-1 my-2"
                    style={{ fontSize: '10px' }}>
                    {row?.schema_type}
                </span>
            )
        },
        {
            key: "allowView",
            label: "Allow to view",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "15%" },
            render: (row) => (
                <div className="stage-toggle custom-switch-wrapper d-flex align-items-center justify-content-center">
                    <InputSwitch
                        className=""
                        type="checkbox"
                        checked={row.isHidden}
                        style={{ cursor: 'pointer', transform: 'scale(0.8)' }}
                        onChange={(e) => upsertFieldConfig(e.value, row, 'hidden')}
                    />
                </div>
            )
        },
        {
            key: "mandatory",
            label: "Mandatory",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "15%" },
            render: (row) => (
                <div className="stage-toggle custom-switch-wrapper d-flex align-items-center justify-content-center">
                    <InputSwitch
                        className=""
                        type="checkbox"
                        checked={row.isRequired}
                        style={{ cursor: 'pointer', transform: 'scale(0.8)' }}
                        onChange={(e) => upsertFieldConfig(e.value, row, 'mandatory')}
                    />
                </div>
            )
        },
        {
            key: "screenCount",
            label: "Screens",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
            render: (row) => (
                <span className="badge rounded-pill bg-light border text-muted fw-bold" style={{ fontSize: '9px' }}>
                    {row.screens_count}
                </span>
            )
        },
        {
            key: "actions",
            label: "Action",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
            render: (row, index, allData) => (
                <div className="d-flex justify-content-center gap-1">
                    <FontAwesomeIcon icon="fa-solid fa-trash" className="text-danger c-pointer" onClick={() => upsertFieldConfig(true, row, 'delete')} />
                </div>
            )
        }
    ];

    const getfieldConfigruationDetails = async () => {
        try {
            setLoader(true)
            const payload = {
                "configuration_id": filterValues?.config?.field_configuration_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETFIELDCONFIGURATIONDETAILS"), payload);
            if (!res?.body?.error_status) {
                setFieldData(res?.body?.data?.field_configuration_details)
            } else {
                setFieldData([])
            }
        } catch (error) {
            console.error("error::", error)
        } finally {
            setLoader(false)
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const upsertFieldConfig = async (newValue, row, type) => {
        try {
            const payload = {
                "field_configuration_item_id": row?.field_configuration_item_id,
                "is_hidden": type === 'hidden' ? newValue : row.isHidden,
                "is_require": type === 'mandatory' ? newValue : row.isRequired,
                "is_deleted": type === 'delete' ? newValue : false
            }

            const res = await services.getInvokeRemote("POST", Urls("UPSERTFIELDCONFIGURATIONDETAILS"), payload);
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
                if (type === 'delete') {
                    setFieldData(prevData =>
                        prevData.filter(item => item.field_configuration_item_id !== row.field_configuration_item_id)
                    );
                } else {
                    setFieldData(prevData => prevData.map(item =>
                        item.field_configuration_item_id === row.field_configuration_item_id
                            ? {
                                ...item,
                                isHidden: type === 'hidden' ? newValue : item.isHidden,
                                isRequired: type === 'mandatory' ? newValue : item.isRequired
                            }
                            : item
                    ));
                }
            } else {
                showError("Error", res.body.message);
            }
        } catch (error) {
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
            console.error("error::", error)
        }
    }


    return { columns, fieldData, option, multiSelectRef, loader }
}